<template>
    <div class="order-summary">
        <h3 class="title is-4 has-text-grey">
            {{ $t('orderDetails.labels.summary') }}
        </h3>
        <div class="summary__list">
            <div class="summary__entry">
                <span class="entry__label">{{
                    $t('checkout.paymentDetails.paymentMethod')
                }}</span
                ><span class="entry__value">{{
                    $t(
                        `checkout.paymentMethodLabels.${paymentDetails.billingPaymentMethod}`
                    )
                }}</span>
            </div>
            <div class="summary__entry" v-if="paymentDetails.billingPaymentMethod === 'billing'">
                <span class="entry__label">Zahlungsbedingungen</span>
                    <span class="entry__value" v-if="termsOfPayment">
                        {{ termsOfPayment }}
                    </span>
                    <span class="entry__value" v-else>
                        {{ $t('checkout.defaultTermsOfPayment') }}
                    </span>
                <template>
                </template>
            </div>
            <div class="summary__entry">
                <span class="entry__label">Produktionszeit</span
                ><span class="entry__value">
                    <template v-if="cumulatedProductionTime > 0">
                        {{
                            $tc(
                                'checkout.productionTimeDays',
                                cumulatedProductionTime
                            )
                        }}
                    </template>
                    <template v-else>--</template>
                </span>
            </div>
            <div class="summary__entry">
                <span class="entry__label">Voraussichtl. Versandzeit</span
                ><span class="entry__value"
                    ><template v-if="cumulatedProductionTime > 0"
                        >{{
                            $tc(
                                'checkout.productionTimeDays',
                                shippingMethod.shippingTimeDays
                            )
                        }}
                    </template>
                    <template v-else>--</template></span
                >
            </div>
            <div class="summary__entry">
                <span class="entry__label">Voraussichtl. Gesamtlieferzeit</span>
                <template v-if="cumulatedProductionTime > 0">
                    <strong class="entry__value">
                        {{
                            $tc(
                                'checkout.productionTimeDays',
                                shippingMethod.shippingTimeDays +
                                    cumulatedProductionTime
                            )
                        }}
                    </strong>
                </template>
                <template v-else><span class="entry__value">--</span></template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'OrderSummary',
    computed: {
        ...mapGetters([
            'paymentDetails',
            'availablePaymentMethods',
            'allCartItems',
            'positionPrice',
            'cumulatedProductionTime',
            'orderTrackingInfo',
            'userAccountDetails',
        ]),
        chosenPaymentMethod() {
            if (this.paymentDetails) {
                return this.paymentDetails.billingPaymentMethod;
            } else {
                return '';
            }
        },
        shippingMethod() {
            return this.$store.getters
                .shippingCountryById(
                    this.paymentDetails.shippingAddress.countryId
                )
                .shippingMethods.find(
                    (method) =>
                        method.shippingMethodId ===
                        this.paymentDetails.shippingMethodId
                );
        },
        productionTimeDays() {
            let productionTimeDays = 0;
            return 5;
        },
        deliveryTimeDays() {
            return this.productionTimeDays;
        },
        termsOfPayment() {
            return this.userAccountDetails?.termsOfPayment;
        }
    },
};
</script>

<style scoped lang="scss">
strong.entry__value {
    font-weight: normal;
    font-family: TTHovesProBold, Helvetica, Arial, sans-serif;
}
</style>
